import React, { useEffect } from 'react';

import { Divider, Grid } from '@mui/material';

import {
    Text,
    Button,
    Select,
    Switch,
    Tabs,
    Combo,
    Documents
} from 'core/components';

import * as enums from 'core/enums';
import * as icons from 'core/icons';

import Definicion from './Tabs/TabDefinicion';
import Detalles from './Tabs/TabDetalles';
import Tareas from './Tabs/TabTareas';
import Liquidaciones from './Tabs/TabLiquidaciones';
import Formularios from './Tabs/TabFormularios';

import { Chip } from '../../../../core/components/library';
import * as helpers from '../../../../core/helpers';

const Detalle = props => {
    const { values, editing, handleChange, refresh } = props;

    return (
        <form autoComplete='off' noValidate>
            <Grid container spacing={1}>
                <Grid item xs={2}>
                    <Select
                        fullWidth
                        name='clase'
                        label='Clase'
                        value={values.clase}
                        onChange={handleChange}
                        editing={editing}
                        options={enums.claseTramite}
                    />
                </Grid>
                <Grid item xs>
                    <Text
                        fullWidth
                        name='descripcion'
                        label='Descripción'
                        value={values.descripcion}
                        onChange={handleChange}
                        editing={editing}
                    />
                </Grid>
            </Grid>
            <Tabs
                tabs={[
                    {
                        label: 'Definicion',
                        icon: icons.DefinicionIcon,
                        component: <Definicion {...props} />,
                        hide: false
                    },
                    {
                        label: 'Detalles',
                        icon: icons.DetailIcon,
                        component: <Detalles {...props} />,
                        hide: false
                    },
                    {
                        label: 'Tareas',
                        icon: icons.TareasIcon,
                        component: <Tareas {...props} />,
                        hide: values && values.seguimiento ? false : true
                    },
                    {
                        label: 'Liquidación',
                        icon: icons.LiquidacionesIcon,
                        component: <Liquidaciones {...props} />,
                        hide: values && values.liquidacion ? false : true
                    },
                    {
                        label: 'Formularios',
                        icon: icons.PrintIcon,
                        component: <Formularios {...props} />,
                        hide: false
                    }
                ]}
            />
        </form>
    );
};

export default Detalle;
